(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/digital-tickets-form.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/digital-tickets/components/digital-tickets-form/digital-tickets-form.js');
"use strict";

const {
  BillingInformation
} = svs.ticket_partner.digitalTickets.digitalTicketsForm.billingInformation;
const {
  RegisterNew
} = svs.ticket_partner.digitalTickets.digitalTicketsForm.registerNew;
const {
  SelectDigitalTickets
} = svs.ticket_partner.digitalTickets.digitalTicketsForm.selectDigitalTickets;
const {
  GridRow,
  GridCol
} = svs.ui.ReactGrid;
const {
  ButtonRowSubmit
} = svs.ticket_partner.sharedComponents.buttonRow;
const {
  HEADER,
  ORDER_LABEL
} = svs.ticket_partner.digitalTickets.constants.FORMS;
const {
  Form
} = svs.ui.reactForm;
const {
  LoginRegister
} = svs.ticket_partner.digitalTickets.loginRegister;
const {
  useState,
  Fragment,
  useContext
} = React;
const {
  DIGITAL_TICKETS_RECEIPT
} = svs.ticket_partner.constants.routes;
const {
  ORDER_SUCCESS
} = svs.ticket_partner.digitalTickets.actions;
const DigitalTicketsForm = _ref => {
  let {
    history
  } = _ref;
  const {
    isLoggedIn,
    companyDetailsPromise
  } = svs.ticket_partner.useUserContext();
  const {
    state,
    dispatch
  } = useContext(svs.ticket_partner.DigitalTicketsContext);
  const [isRegisterNew, setIsRegisterNew] = useState(false);
  const handleSubmit = async (e, formData) => {
    e && e.preventDefault();
    if (_.values(formData).some(_ref2 => {
      let {
        isValid
      } = _ref2;
      return !isValid;
    })) {
      return;
    }
    const orderCb = async () => {
      try {
        let digitalOrderRequest;
        if (isLoggedIn) {
          const {
            companyDetails
          } = await companyDetailsPromise;
          digitalOrderRequest = svs.ticket_partner.digitalTickets.utils.createDigitalOrderRequest(state, companyDetails);
        } else {
          digitalOrderRequest = svs.ticket_partner.digitalTickets.utils.createDigitalOrderRequest(state);
        }
        await svs.ticket_partner.services.createDigitalOrder(digitalOrderRequest);
        dispatch({
          type: ORDER_SUCCESS
        });
        history.push(DIGITAL_TICKETS_RECEIPT);
      } catch (e) {
        const errorMessage = svs.ticket_partner.services.mapDigitalOrderError(e);
        svs.ticket_partner.utils.showErrorDialog(errorMessage);
      }
    };
    const sum = Object.values(state.articles).reduce((acc, _ref3) => {
      let {
        price,
        count
      } = _ref3;
      return price * count + acc;
    }, 0);
    const rows = Object.values(state.articles).filter(_ref4 => {
      let {
        count
      } = _ref4;
      return count > 0;
    }).map(_ref5 => {
      let {
        articleId,
        count
      } = _ref5;
      return {
        articleId,
        count
      };
    });
    svs.ticket_partner.utils.showSummaryDialog(orderCb, {
      sum,
      rows
    }, svs.ticket_partner.data.articles.ticketsDigital);
  };
  return React.createElement(Fragment, null, React.createElement(Form, {
    onSubmit: handleSubmit
  }, React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    lg: {
      col: 8
    },
    md: {
      col: 10
    },
    sm: {
      col: 12
    },
    xl: {
      col: 6
    },
    xs: 12
  }, React.createElement("h1", null, HEADER), React.createElement(SelectDigitalTickets, null), isRegisterNew ? React.createElement(RegisterNew, null) : null, isLoggedIn || isRegisterNew ? React.createElement(BillingInformation, null) : null)), isLoggedIn || isRegisterNew ? React.createElement(ButtonRowSubmit, {
    label: ORDER_LABEL
  }) : null), isLoggedIn || isRegisterNew ? null : React.createElement(GridRow, {
    className: "u-flex-justify-content-center"
  }, React.createElement(GridCol, {
    className: "u-text-left",
    lg: {
      col: 8
    },
    md: {
      col: 10
    },
    sm: {
      col: 12
    },
    xl: {
      col: 6
    },
    xs: 12
  }, React.createElement(LoginRegister, {
    handleNewCustomer: () => setIsRegisterNew(true)
  }))));
};
svs.ticket_partner.digitalTickets.DigitalTicketsForm = DigitalTicketsForm;

 })(window);